import React from "react"
import "./WelcomeModal.css"
import { getTranslation } from "../../assets/creator/translations"

const WelcomeOnFirstVisit = props => (
	<React.Fragment>
		<div className='welcome firstVisit'>
			{" "}
			<div className='welcome-modal__title'>
				{getTranslation("Msg_WelcomeFirstTime")}
			</div>
			<div className='welcome-modal-conatiner'>
				<div className='welcome-modal__text firstVisit-text-1'>
					{getTranslation("Msg_DesignYourShop")}
				</div>
				<div className='welcome-modal__text firstVisit-text-2'>
					<br></br>
					{getTranslation("Msg_DesignYourShopText2")}
				</div>
			</div>
			<div className='welcome-modal__btn-group'>
				{/* <button
					className='welcome-modal__btn welcome-modal__btn--non-active'
					onClick={props.handleClose}>
					{getTranslation("Btn_Begin")}
				</button> */}
				<button
					className='welcome-modal__btn welcome-modal__btn--active nextBtn'
					onClick={props.handleOpenTemplatesMenu}>
					{getTranslation("Btn_EditPredefinedTemplateFirstVisit")}
				</button>
			</div>
				<span className="border-line"></span>
		</div>
	</React.Fragment>
)

const WelcomeOnConsecutiveVisit = props => (
	<React.Fragment>
		<div className='welcome consecutiveVisit'>
			<div className='welcome-modal__title'>
				{getTranslation("Msg_WelcomeAgain")}
			</div>

			<div className='welcome-modal__text'>
				<p>{getTranslation("Msg_WeSavedYourProject")}</p>
				<p>{getTranslation("Msg_ContinueOrMakeNewProject")}</p>
			</div>

			<div className='welcome-modal__btn-group'>
				{/* <button
					className='welcome-modal__btn welcome-modal__btn--non-active'
					onClick={props.handleClear}>
					{getTranslation("NewProject")}
				</button> */}
				<p className='welcome-modal__link continueEditProjectBtn' onClick={props.handleRestore}>
					{getTranslation("Btn_EditPreviousTemplate")}
				</p>
				<button
					className='welcome-modal__btn welcome-modal__btn--active createNewProjectBtn'
					onClick={props.handleOpenNextMenu}>
					{getTranslation("Btn_EditPredefinedTemplate")}
				</button>
			</div>
			<span className="border-line"></span>
		</div>
	</React.Fragment>
)

const WelcomeMessage = props => {
	if (props.isMemoryEmpty()) {
		return <WelcomeOnFirstVisit {...props} />
	} else {
		return <WelcomeOnConsecutiveVisit {...props} />
	}
}

const WelcomeModal = props =>
	props.show && (
		<div className='welcome-modal'>
			<section className='welcome-modal__main '>
				<WelcomeMessage {...props} />
			</section>
		</div>
	)

export default WelcomeModal
